import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'

import router from './router';

// 引入 i18n
import { createI18n } from 'vue-i18n';

import zhCn from 'element-plus/dist/locale/zh-cn'; // 修改导入路径
import en from 'element-plus/dist/locale/en'; // 修改导入路径
import zhTw from "element-plus/dist/locale/zh-tw"
import ko from "element-plus/dist/locale/ko"
import ar from "element-plus/dist/locale/ar"
import vi from "element-plus/dist/locale/vi"

// 创建 i18n 实例
const i18n = createI18n({
    locale: 'zh-cn', // 设置语言环境
    messages: {
        'zh-cn': {
            "element": zhCn,
            "newNotify": {
                "platformNo": "请先在平台登录该账号",
                // "Cash100":"充值金额不能低于100人民币"
                "networkError": "网络错误，请重新重试",
            },
            "index": {
                "slogan": "星遇互游,让直播更简单",
                "customText": '每一个环节，都经过深思熟虑，只为了提供更好的直播服务。',
                "goButton": "点击确认",
                "placeholder": "请输入平台账号",
                "cardKeyError": '卡密不存在或输入错误',
                "game_message": "请选择需要充值的游戏。",
                "placeholder_user": "请输入平台密码"
            },
            "pay": {
                "platformUser": "平台账号",
                "payText": "游戏充值",
                "payTotalTxt": "请仔细确认后，再点击充值",
                "CNY": "人民币",
                "CNYText": "请输入充值金额",
                "gameBalance": "游戏余额",
                "gameText": "游戏额度(输入金额自动计算)",
                "wechatPay": "点击充值(微信)",
                "alipayPay": "点击充值(支付宝)",
                "paypalPay": "点击充值(PayPal)",
                "switchCard": "切换账号",
                "wechatPayText": "请打开微信,扫描二维码，微信支付",
                "paySuccess": "充值成功,祝您开播愉快",
                "errorSuccess": "卡密不存在或输入错误，请核对后重试。",
                "customer": "联系我们"
            },
            "notify": {
                "tiktokidNULL": "tiktok账号不能为空",
                "moneyNULL": "金额不能为空",
                "cardNULL": "卡密不能为空",
                "platformNULL": "请选择充值平台"
            }
        },
        "zh-tw": {
            "element": zhTw,
            "newNotify": {
                "platformNo": "請先在平台登入該帳號",
                "networkError": "網絡錯誤，請重新重試",
            },
            "index": {
                "slogan": "星遇互遊,讓直播更簡單",
                "customText": '每一個環節，都經過深思熟慮，只為了提供更好的直播服務。',
                "goButton": "點擊確認",
                "placeholder": "請輸入平台帳號",
                "cardKeyError": '卡密不存在或輸入錯誤，請核對後重試。',
                "game_message": "請選擇需要充值的遊戲。",
                "placeholder_user": "請輸入平台密碼。"
            },
            "pay": {
                "platformUser": "平台帳號",
                "payText": "遊戲充值",
                "payTotalTxt": "請仔細確認後，再點擊充值",
                "CNY": "CNY",
                "CNYText": "請輸入充值金額",
                "gameBalance": "遊戲余額",
                "gameText": "遊戲額度(輸入金額自動計算)",
                "wechatPay": "點擊充值(微信)",
                "paypalPay": "點擊充值(PayPal)",
                "alipayPay": "點擊充值(Alipay)",
                "switchCard": "切換帳號",
                "wechatPayText": "請打開微信,掃描二維碼，微信支付",
                "paySuccess": "充值成功,祝您開播愉快",
                "errorSuccess": "卡密不存在或輸入錯誤，請核對後重試。",
                "customer": "聯系我們"
            },
            "notify": {
                "tiktokidNULL": "tiktok賬號不能為空",
                "moneyNULL": "金額不能為空",
                "cardNULL": "卡密不能為空",
                "platformNULL": "請選擇充值平台"

            }
        },
        'en': {
            "element": en,
            "newNotify": {
                "platformNo": "Please log in to the account on the platform first",
                "networkError": "Network error, please try again",

            },
            "index": {
                "slogan": "Star Encounter,Make live streaming easier",
                "customText": 'Every aspect has been carefully considered to provide better live streaming services.',
                "goButton": "Go",
                "placeholder": "Please enter your platform account",
                "cardKeyError": 'The card key does not exist or the input is incorrect, please try again after checking.',
                "game_message": "Please select the game you need to recharge.",
                "placeholder_user": "Please enter the platform password"

            },
            "pay": {
                "platformUser": "Platform Account",
                "payText": "Game recharge",
                "payTotalTxt": "Please confirm it carefully, and then click recharge.",
                "CNY": "CNY",
                "CNYText": "Please enter the recharge amount.",
                "gameBalance": "Game balance",
                "gameText": "Game quota",
                "wechatPay": "Click to recharge (WeChat)",
                "paypalPay": "Click to recharge (PayPal)",
                "alipayPay": "Click to recharge (Alipay)",
                "switchCard": "Switch Account",
                "wechatPayText": "Please open wechat, scan the QR code, wechat Pay",
                "paySuccess": "Top up successfully. Have a nice start",
                "errorSuccess": "The password does not exist or the input is incorrect. Please check and try again",
                "customer": "Contact us"
            },
            "notify": {
                "tiktokidNULL": "TikTok account cannot be empty",
                "moneyNULL": "The amount cannot be empty",
                "cardNULL": "The password cannot be empty",
                "platformNULL": "Please select a recharge platform"
            }
        },
        'ko': {
            "element": ko,
            "newNotify": {
                "platformNo": "먼저 플랫폼에서 해당 계정으로 로그인하세요",
                "networkError": "네트워크 오류, 다시 시도하세요",

            },
            "index": {
                "slogan": "Star Encounter,생방송을 더욱 쉽게 할 수 있도록 하다.",
                "customText": '매 환절마다 심사숙고를 거쳐 오직 더욱 좋은 생방송서비스를 제공하기 위해서이다.',
                "goButton": "확인 클릭",
                "placeholder": "플랫폼 계정을 입력해 주세요.",
                "cardKeyError": '비밀 카드가 존재하지 않거나 입력 오류가 있습니다. 대조 후 다시 시도하십시오.',
                "game_message": "충전이 필요한 게임을 선택해 주세요.",
                "placeholder_user": "플랫폼 비밀번호를 입력하세요"

            },
            "pay": {
                "platformUser": "플랫폼 계정",
                "payText": "게임 충전",
                "payTotalTxt": "자세한 확인 후 충전 클릭",
                "CNY": "CNY",
                "CNYText": "충전 금액을 입력하세요",
                "gameBalance": "게임 잔액",
                "gameText": "게임 한도 (입력 금액 자동 계산)",
                "wechatPay": "클릭하여 충전(wechat)",
                "alipayPay": "클릭하여 충전(Alipay)",
                "paypalPay": "클릭하여 충전(PayPal)",
                "switchCard": "계정 전환",
                "wechatPayText": "Wechat을 열고 QR코드, Wechat Pay를 스캔하십시오.",
                "paySuccess": "충전 성공, 즐거운 방송 되세요",
                "errorSuccess": "암호가 없거나 입력 오류가 있습니다. 확인 후 다시 시도하십시오.",
                "customer": "연락처"
            },
            "notify": {
                "tiktokidNULL": "틱톡 계정은 비워둘 수 없습니다.",
                "moneyNULL": "금액은 비워둘 수 없습니다.",
                "cardNULL": "커미는 비워둘 수 없습니다",
                "platformNULL": "충전 플랫폼을 선택해 주세요"
            }
        },
        'ar': {
            "element": ar,
            "newNotify": {
                "platformNo": "يرجى تسجيل الدخول إلى هذا الحساب على المنصة أولاً",
                "networkError": "خطأ في الشبكة، يرجى المحاولة مرة أخرى",
                // "Cash100":"充值金额不能低于100人民币" // 如需翻译也可补充
            },
            "index": {
                "slogan": "Xingyu Huyou، نجعل البث المباشر أسهل",
                "customText": "كل مرحلة مدروسة بعناية لتقديم أفضل خدمة بث مباشر.",
                "goButton": "انقر للتأكيد",
                "placeholder": "يرجى إدخال حساب المنصة",
                "cardKeyError": "رمز البطاقة غير موجود أو تم إدخاله بشكل غير صحيح",
                "game_message": "يرجى اختيار اللعبة التي تريد شحنها.",
                "placeholder_user": "يرجى إدخال كلمة مرور المنصة"

            },
            "pay": {
                "platformUser": "حساب المنصة",
                "payText": "شحن اللعبة",
                "payTotalTxt": "يرجى التحقق بعناية قبل النقر على زر الشحن",
                "CNY": "يوان صيني",
                "CNYText": "يرجى إدخال مبلغ الشحن",
                "gameBalance": "رصيد اللعبة",
                "gameText": "رصيد اللعبة (يتم حسابه تلقائياً عند إدخال المبلغ)",
                "wechatPay": "انقر للشحن (WeChat)",
                "alipayPay": "انقر للشحن (Alipay)",
                "paypalPay": "انقر للشحن (PayPal)",
                "switchCard": "تبديل الحساب",
                "wechatPayText": "يرجى فتح WeChat ومسح رمز QR للدفع",
                "paySuccess": "تم الشحن بنجاح، نتمنى لك بثاً ممتعاً",
                "errorSuccess": "رمز البطاقة غير موجود أو غير صحيح، يرجى التحقق والمحاولة مرة أخرى.",
                "customer": "اتصل بنا"
            },
            "notify": {
                "tiktokidNULL": "لا يمكن أن يكون حساب TikTok فارغاً",
                "moneyNULL": "لا يمكن أن يكون المبلغ فارغاً",
                "cardNULL": "لا يمكن أن يكون رمز البطاقة فارغاً",
                "platformNULL": "يرجى اختيار منصة الشحن"
            }
        },
        'vi': {
            "element": vi,
            "newNotify": {
                "platformNo": "Vui lòng đăng nhập tài khoản này trên nền tảng trước",
                "networkError": "Lỗi mạng, vui lòng thử lại",
                // "Cash100":"充值金额不能低于100人民币" // 如需翻译也可补充
            },
            "index": {
                "slogan": "Xingyu Huyou, giúp livestream trở nên dễ dàng hơn",
                "customText": "Mỗi bước đều được suy nghĩ kỹ lưỡng để mang đến dịch vụ livestream tốt hơn.",
                "goButton": "Nhấn để xác nhận",
                "placeholder": "Vui lòng nhập tài khoản nền tảng",
                "cardKeyError": "Mã thẻ không tồn tại hoặc nhập sai",
                "game_message": "Vui lòng chọn trò chơi cần nạp.",
                "placeholder_user": "Vui lòng nhập mật khẩu nền tảng"
            },
            "pay": {
                "platformUser": "Tài khoản nền tảng",
                "payText": "Nạp game",
                "payTotalTxt": "Vui lòng kiểm tra kỹ trước khi nhấn nút nạp",
                "CNY": "Nhân dân tệ",
                "CNYText": "Vui lòng nhập số tiền cần nạp",
                "gameBalance": "Số dư game",
                "gameText": "Hạn mức game (tự động tính khi nhập số tiền)",
                "wechatPay": "Nhấn để nạp (WeChat)",
                "alipayPay": "Nhấn để nạp (Alipay)",
                "paypalPay": "Nhấn để nạp (PayPal)",
                "switchCard": "Chuyển tài khoản",
                "wechatPayText": "Vui lòng mở WeChat và quét mã QR để thanh toán",
                "paySuccess": "Nạp thành công, chúc bạn livestream vui vẻ",
                "errorSuccess": "Mã thẻ không tồn tại hoặc nhập sai, vui lòng kiểm tra lại.",
                "customer": "Liên hệ chúng tôi"
            },
            "notify": {
                "tiktokidNULL": "Tài khoản TikTok không được để trống",
                "moneyNULL": "Số tiền không được để trống",
                "cardNULL": "Mã thẻ không được để trống",
                "platformNULL": "Vui lòng chọn nền tảng nạp tiền"
            }
        }



    }
});


const app = createApp(App)

// Debug 浏览器信息
console.log("=== Debug 浏览器环境 ===")
console.log("UA:", navigator.userAgent)
console.log("JS enabled:", typeof window === "object")
console.log("webdriver:", navigator.webdriver)
console.log("localStorage:", typeof localStorage)
console.log("cookieEnabled:", navigator.cookieEnabled)
console.log("平台:", navigator.platform)
console.log("=======================")

app.use(ElementPlus)

app.use(i18n);

app.use(router)
app.mount('#app')
